export enum ParallelExport {
    Combined = "Combined",
    Separated = "Separated",
}
